module.exports = __webpack_public_path__ + "media/fonts/ppneuemachina-ultrabold-webfont-5d9d5489a07c9d1a95fe5f729a776e1b.woff2";